const videoPlayButton = document.querySelectorAll(".js-video-play-button"),
    vimeoElement = document.querySelector("#js-vimeo-embed");    
    
let youtubeElement = document.querySelector(".js-youtube-embed"),
    vimeoPlayer = new Vimeo.Player(vimeoElement),
    videoID = '',
    youtubePlayer,
    Vimeo;

	vimeoPlayer.setVolume(1);

var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";

var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

function onYouTubeIframeAPIReady() { 
    youtubePlayer = new YT.Player('js-youtube-embed', {
    height: '390',
    width: '640',
    videoId: videoID,
    playerVars: { 'autoplay':0, 'controls': 1,'autohide':1,'origin':'window.location' }
    });

    youtubeElement = document.querySelector(".js-youtube-embed");
}

if (typeof videoPlayButton != "undefined" && videoPlayButton != null && videoPlayButton.length > 0) { 
    videoPop();
}

function videoPop() {
    const videoOverlay = document.querySelector(".js-video-overlay"),
        closeVideoOverlayBtn = document.querySelector(".js-close-video-overlay-btn"),

        isActiveClass = 'is-active',
        stopScrollingClass = 'stop-scrolling';

        videoPlayButton.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();

                //add classes an open the overlay
                videoOverlay.classList.add(isActiveClass);
                body.classList.add(stopScrollingClass);

                let videoType = btn.dataset.type,
                    videoID = btn.dataset.id;
              
                if (videoType == 'youtube') {
                    youtubePlayer.loadVideoById(videoID, 0, "default");
                    gsap.set(vimeoElement, { autoAlpha: 0 });
                    gsap.set(youtubeElement, { autoAlpha: 1 });
                } else {
                    vimeoPlayer.loadVideo(videoID);                    
                    vimeoPlayer.play();
                    gsap.set(vimeoElement, { autoAlpha: 1 });
                    gsap.set(youtubeElement, { autoAlpha: 0 });
                }            
                
            });
        });

        closeVideoOverlayBtn.addEventListener("click", (e) => {
            e.preventDefault();

            youtubePlayer.pauseVideo();
            vimeoPlayer.pause();

            videoOverlay.classList.remove(isActiveClass);
            body.classList.remove(stopScrollingClass);
        });

}